import { gql } from "@apollo/client";

export const LIST_GPS_DEVICES = gql`
    query ListVehiclesGraphQL(
        $vehicleSearchTerm: String
        $filterInput: ListVehiclesFilterInput
        $first: Int
        $after: Cursor
        $stakeholderAndVehicleCenterInputs: [StakeholderAndVehicleCenterInput!]!
    ) {
        listVehicles(input: {
            stakeholderAndVehicleCenterInputs: $stakeholderAndVehicleCenterInputs
            vehicleSearchTerm: $vehicleSearchTerm
            first: $first
            after: $after
            filterInput: $filterInput
        }) {
            vehicles {
                id
                displayName
                photoUrl
                vin
                licensePlate
                sourceVehicleId
                oemId
                stakeholderId
                vehicleManagementHubId

                gpsDevice {
                    id
                    name
                    deviceType
                    serialNumber
                    deviceStatus {
                        isDeviceCommunicating
                        isDriving
                        latitude
                        longitude
                        # speed
                        geocodeAddress {
                            city
                            country
                            formattedAddress
                            postalCode
                            streetName
                            streetNumber
                        }
                    }
                }
            }
            metaData {
                first
                nextCursor
            }
            filterAggregations {
                oemIds
                stakeholderIds
                vehicleManagementHubIds
                tiers
                years
                makes
                vehiclesCount {
                    filtered
                    total
                }
                odometerRange {
                    min
                    max
                }
            }
        }
    }
`;
